import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeGetProductDefaults, makeGetSelectedColorId } from '../../../redux/product/selectors/ProductSelector';
import { productPreviewActions } from '../../../redux/productPreview/actions/ProductPreviewActions.creators';
import { makeGetShowImageTouchZoomHint } from '../../../redux/productPreview/selectors/ProductPreviewSelectors';
import ProductPreview from '../product-preview/ProductPreview';
export const ProductMediaSlider = () => {
    const selectedColorId = useSelector(makeGetSelectedColorId());
    const showImageTouchZoomHint = useSelector(makeGetShowImageTouchZoomHint());
    const { productId } = useSelector(makeGetProductDefaults());
    const dispatch = useDispatch();
    const productPreviewRef = useRef(null);
    const handleImageTouchZoom = () => {
        dispatch(productPreviewActions.disableImageTouchZoomHint());
    };
    return (_jsx(ProductPreview, { innerRef: productPreviewRef, selectedColorId: selectedColorId, productId: productId, showImageTouchZoomHint: showImageTouchZoomHint, disableLightbox: true, onImageTouchZoom: handleImageTouchZoom, showLabels: false }));
};
